/**
 * useWaitingOnMe — approvals and conversations that need a human decision,
 * scoped to the rail's active module. Drives the rail count badge.
 */
import { useQuery } from '@tanstack/react-query';
import { getWaitingOnMeOptions } from '../generated/api/@tanstack/react-query.gen.js';

export function useWaitingOnMe(moduleId: string) {
  const query = useQuery({
    // `moduleId` omitted / 'all' = every enabled module.
    ...getWaitingOnMeOptions({ query: moduleId && moduleId !== 'all' ? { moduleId } : undefined }),
    refetchInterval: 30_000,
  });
  if (query.isError) console.error('useWaitingOnMe: failed to load waiting-on-me', query.error);
  return query;
}
